import { createContext, useContext } from "react";
import type { Formatters } from "./format";
import type { DashboardSnapshot } from "./types";

export interface SnapshotContextValue {
  data: DashboardSnapshot;
  fmt: Formatters;
  now: Date;
}

// Kept out of snapshot.tsx so that file exports only the provider component:
// Fast Refresh bails on a module that mixes components with other exports.
export const SnapshotContext = createContext<SnapshotContextValue | null>(null);

export function useSnapshot(): SnapshotContextValue {
  const ctx = useContext(SnapshotContext);
  if (!ctx) throw new Error("useSnapshot must be used inside SnapshotProvider");
  return ctx;
}
